module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hY0fn"))).then(() => parcelRequire('dJXJK'));